var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamsterSvgrepoCom2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFCC4D",
    cx: 8.5,
    cy: 9.5,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFCC4D",
    cx: 27.5,
    cy: 9.5,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA596E",
    d: "M13.912 5.854a6.886 6.886 0 0 0-5.443-2.667a6.907 6.907 0 0 0-6.906 6.906a6.9 6.9 0 0 0 3.996 6.256c.709-4.195 3.983-8.672 8.353-10.495zm13.619-2.666a6.884 6.884 0 0 0-5.443 2.667c4.369 1.823 7.643 6.3 8.354 10.496a6.902 6.902 0 0 0-2.911-13.163z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFE8B6",
    d: "M34 22.593c-2-10.045-11.333-6.5-16-6.5s-14-3.546-16 6.5c-1.295 6.504 3.794 9.879 9.032 11.387C12.682 35.212 15.19 36 18 36c2.81 0 5.318-.788 6.969-2.021c5.237-1.508 10.326-4.882 9.031-11.386z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC4D",
    d: "M30.6 18c0 11-5.641 6-12.6 6S5.4 29 5.4 18c0-5.799 5.641-13 12.6-13s12.6 7.201 12.6 13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA596E",
    d: "M20.905 27.956c0 1.604-2.012 3.352-2.905 3.352c-.894 0-2.905-1.748-2.905-3.352C15.095 26.351 16.882 26 18 26c1.117 0 2.905.351 2.905 1.956z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M35.515 30.303c-5.245-3.146-12.355-2.175-12.656-2.133c-.014.002-.023.011-.037.013c-.081.015-.153.048-.228.081c-.046.021-.093.035-.134.062c-.061.039-.107.092-.158.144c-.041.041-.084.076-.117.123c-.036.052-.056.111-.082.17c-.027.062-.058.121-.071.189c-.004.016-.015.028-.018.045c-.009.055.006.105.006.159c-.001.049-.016.095-.009.146c.002.016.012.027.015.042c.013.069.041.13.067.193c.024.06.044.12.079.173c.028.044.067.076.101.115c.053.058.104.114.168.158c.038.026.083.041.125.062c.074.036.146.07.229.087c.015.003.026.013.041.016c.056.01 5.636.977 8.364 4.613c.196.263.496.4.801.4a.998.998 0 0 0 .799-1.599c-1.108-1.479-2.573-2.566-4.025-3.369c1.88.242 3.942.765 5.711 1.826a.998.998 0 0 0 1.372-.342c.284-.476.13-1.09-.343-1.374zm-21.686-.596c.034-.052.053-.111.077-.169c.026-.064.055-.124.068-.193c.003-.016.013-.028.016-.044c.007-.053-.008-.103-.009-.154c0-.051.014-.1.005-.151c-.002-.016-.013-.027-.016-.043c-.015-.069-.045-.131-.074-.194c-.025-.057-.045-.115-.08-.165c-.032-.047-.075-.082-.115-.123c-.051-.053-.099-.105-.16-.146c-.04-.025-.087-.039-.131-.06a.983.983 0 0 0-.23-.081c-.014-.003-.024-.012-.038-.014c-.301-.042-7.412-1.014-12.656 2.133a1 1 0 1 0 1.029 1.714c1.768-1.061 3.83-1.583 5.709-1.825c-1.451.802-2.915 1.89-4.023 3.368A.998.998 0 0 0 4 35.159a1 1 0 0 0 .801-.4c2.717-3.622 8.31-4.604 8.366-4.613c.015-.003.025-.012.04-.016c.077-.016.144-.049.214-.082c.048-.022.099-.039.142-.069c.059-.04.104-.093.152-.144c.039-.042.082-.079.114-.128z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272B2B",
    d: "M10 20s0-2 2-2s2 2 2 2v2s0 2-2 2s-2-2-2-2v-2zm12 0s0-2 2-2s2 2 2 2v2s0 2-2 2s-2-2-2-2v-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamsterSvgrepoCom2);
export default __webpack_public_path__ + "static/media/hamster-svgrepo-com-2.9ad8b989eb320f2d6f7d935a2da6203a.svg";
export { ForwardRef as ReactComponent };